import * as echarts from 'echarts'

// var myChart = null
const setCharts = (chartDom, title, legendData, Xdata, seriesData) => {
  echarts.dispose(chartDom)
  var myChart = echarts.init(chartDom)
  // if (myChart === null) { // 只有第一次才实例化
  //   myChart = echarts.init(chartDom)
  // }
  var option = {
    title: {
      top: '13%',
      left: '4%',
      text: title,
      subtext: ''
    },
    legend: {
      data: legendData
    },
    tooltip: {
      trigger: 'axis',
    },
    grid: {
      top: '13%',
      left: '4%',
      right: '4%'
    },
    // toolbox: {
    //   show: true,
    //   feature: {
    //     mark: { show: true },
    //     dataView: { show: true, readOnly: false },
    //     magicType: { show: true, type: ['line', 'bar'] },
    //     restore: { show: true },
    //     saveAsImage: { show: true }
    //   }
    // },
    xAxis: {
      // axisLabel: {
      //   interval: 0,
      //   rotate: rotate,
      //   position: 'center'
      //   // margin: -280, //刻度标签与轴线之间的距离
      // },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      type: 'category',
      data: Xdata
    },
    yAxis: [
      {
        type: 'value',
        // name: '单位: %',
        axisLabel: {
          show: true,
          interval: 'auto'
          // formatter: function (value) {
          //   return (value*100) + '%';
          // }
        },
        min: 'dataMin',
        max: 'dataMax',
      },
      {
        type: 'value',
        // name: '单位: %',
        axisLabel: {
          show: true,
          interval: 'auto',
          formatter: function (value) {
            return (value) + '%';
          }
        },
        splitLine: {
          show: false
        }
      },
    ],
    // series: [
    //   {
    //     type: 'line',
    //     data: Ydata[0],
    //     smooth: true,
    //     showSymbol: false,
    //     symbol: 'none',
    //     lineStyle: {
    //       color: 'black',
    //       width: 1,
    //       emphasis: {
    //         width: 1
    //       }
    //     }
    //   },
      
    // ]
    series: seriesData
  }
  option && myChart.setOption(option)
  return myChart
}

export { setCharts }
